import type { DailyCall } from "@daily-co/daily-js"

/** Use the browser's device order, before daily-react sorts devices by their labels. */
export async function getDefaultMicrophoneId(call: DailyCall): Promise<string | undefined> {
  try {
    const { devices } = await call.enumerateDevices()
    const microphones = devices.filter((device) => device.kind === "audioinput" && device.deviceId)
    // Chromium exposes a dynamic default alias. Safari exposes physical devices only,
    // with the browser's default first. Never infer the default from a device's name.
    // Before permission, IDs can be empty. Keep the default preference so Daily can
    // resolve it when devices become available, without selecting again after joining.
    return (microphones.find((device) => device.deviceId === "default") || microphones[0])?.deviceId ?? "default"
  } catch {
    // Enumeration itself can fail; do not let that prevent preview or joining.
    return undefined
  }
}
